import apiClient from './client'

// Types
export interface DashboardNotification {
  id: number
  type: 'info' | 'success' | 'warning' | 'error' | 'mention' | 'reply' | 'badge' | 'course' | 'event' | 'taskforce' | 'clinic'
  title: string
  message: string
  link?: string
  is_read: boolean
  created_at: string
}

export interface DashboardCourse {
  id: number
  title: string
  slug: string
  progress: number
}

export interface DashboardEvent {
  id: number
  title: string
  start_datetime: string
  type: string
}

export interface DashboardTask {
  id: number
  title: string
  status: 'open' | 'in_progress'
  due_date: string | null
  taskforce_name: string
}

export interface DashboardData {
  user: {
    display_name: string
    role: string
    avatar: string | null
  }
  notifications: {
    unread_count: number
    recent: DashboardNotification[]
  }
  courses: {
    in_progress: DashboardCourse[]
    completed_count: number
  }
  events: {
    upcoming: DashboardEvent[]
  }
  gamification: {
    points: number
    level: number
    badges_count: number
    rank: number | null
  }
  taskforce: {
    pending_tasks: DashboardTask[]
  }
  forum: {
    threads: number
    posts: number
  }
}

export interface ActivityItem {
  type: 'forum_post' | 'lesson_complete' | 'badge_earned'
  title: string
  timestamp: string
  link: string
}

export const dashboardApi = {
  // Get aggregated dashboard data
  getDashboardData: async (): Promise<DashboardData> => {
    const response = await apiClient.get('/dashboard/')
    return response.data
  },

  // Get activity feed
  getActivityFeed: async (): Promise<{ activities: ActivityItem[] }> => {
    const response = await apiClient.get('/dashboard/activity/')
    return response.data
  },

  // Notifications
  getNotifications: async (params?: {
    page?: number
    is_read?: boolean
  }): Promise<{ results: DashboardNotification[]; count: number }> => {
    const response = await apiClient.get('/dashboard/notifications/', { params })
    return response.data
  },

  markNotificationRead: async (id: number): Promise<void> => {
    await apiClient.post(`/dashboard/notifications/${id}/read/`)
  },

  markAllNotificationsRead: async (): Promise<{ message: string }> => {
    const response = await apiClient.post('/dashboard/notifications/read-all/')
    return response.data
  },
}
